export class AddressDto {
  id: number;
  line1: string;
  line2: string;
  line3: string;
  complement: string;
  isResidentAbroad: boolean;
  number: number;
  postalCode: string;
  country: string;
  city: string;
  state: string;

  constructor(
    line1?: string,
    line2?: string,
    line3?: string,
    isResidentAbroad?: boolean,
    complement?: string,
    number?: number,
    postalCode?: string,
    country?: string,
    city?: string,
    state?: string
  ) {
    this.line1 = line1;
    this.line2 = line2;
    this.line3 = line3;
    this.isResidentAbroad = isResidentAbroad;
    this.complement = complement;
    this.number = number;
    this.postalCode = postalCode;
    this.country = country;
    this.city = city;
    this.state = state;
  }
}
